import { heroStats } from "@/mocks/kanliao";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20gradient%20waves%20in%20coral%20orange%20vermilion%20and%20deep%20teal%20tones%20with%20soft%20cream%20highlights%2C%20smooth%20silky%20liquid%20texture%2C%20modern%20minimal%20digital%20art%20background%2C%20calm%20and%20elegant%20atmosphere%2C%20high%20quality%20render%2C%20no%20text%2C%20no%20objects&width=1600&height=1000&seq=kanliao-hero-v1&orientation=landscape"
        alt="看料订阅提醒服务的暖色调渐变背景图"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div
        className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70"
        aria-hidden="true"
      ></div>

      <div className="container-px relative flex w-full flex-col items-center px-4 pt-32 pb-16 text-center md:pt-44 md:pb-24">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-md">
          <i className="ri-flashlight-fill text-sm" aria-hidden="true"></i>
          实时更新监测 · 主动推送提醒
        </span>

        <h1 className="max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-6xl">
          不错过每次更新的
          <span className="relative mx-2 inline-block">
            <span className="relative z-10">订阅提醒</span>
            <span
              className="absolute inset-x-0 bottom-1 z-0 h-3 rounded-sm bg-primary-500/80"
              aria-hidden="true"
            ></span>
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-8 text-white/85 md:text-lg">
          关注新料动态，订阅你关心的栏目与话题。内容一旦更新，推送通知第一时间送达，
          无需反复刷新，让你在动态更新的浪潮中永远快人一步。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#subscribe"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-semibold text-background-50 transition-transform hover:-translate-y-0.5 hover:bg-primary-400 sm:w-auto"
          >
            <i className="ri-notification-badge-line text-lg" aria-hidden="true"></i>
            订阅新料推送
          </a>
          <a
            href="#guide"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-7 py-3.5 text-base font-semibold text-background-50 backdrop-blur-md transition-colors hover:bg-white/20 sm:w-auto"
          >
            了解订阅方式
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <dl className="mt-12 grid w-full max-w-4xl grid-cols-2 gap-3 md:mt-16 md:grid-cols-4">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center rounded-2xl border border-white/15 bg-white/10 px-4 py-5 text-background-50 backdrop-blur-md"
            >
              <i
                className={`${stat.icon} text-2xl text-primary-300`}
                aria-hidden="true"
              ></i>
              <dd className="mt-2 font-heading text-2xl font-black md:text-3xl">
                {stat.value}
              </dd>
              <dt className="mt-1 text-xs text-white/75">{stat.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}